import { render, staticRenderFns } from "./FieldLayout.vue?vue&type=template&id=01b045ef&scoped=true&"
import script from "./FieldLayout.vue?vue&type=script&lang=js&"
export * from "./FieldLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b045ef",
  null
  
)

export default component.exports